import { Icon, Box, Button, Popover, PopoverContent, PopoverTrigger } from '@cad-arc';
import { useState } from 'react';
import { NotificationCounter } from '~/common/components/notification-counter';
import { Export } from '~/common/components/export/export';
import { useEnabledFeatures } from '~/common/hooks/enabled-features/use-enabled-features';
import { useExportsApi } from '../use-exports-api';
import { useExportNotifications } from '../use-exports-notifications';

export function ExportsMenu() {
    const { currentExports } = useExportsApi();
    const [isOpen, setIsOpen] = useState(false);
    const { events, state } = useExportNotifications(currentExports);
    const { mediaAttachmentsEnabled } = useEnabledFeatures();

    function onPopoverChange(newState: boolean) {
        const isClosing = isOpen && !newState;

        if (isClosing) {
            events.onPopoverClose();
        }

        setIsOpen(newState);
    }

    return (
        <Popover hasArrow={false} onOpenChange={onPopoverChange}>
            <PopoverTrigger asChild>
                <Button type="button" size="sm" variant="outline" data-testid="EXPORTS_TRIGGER">
                    <Icon icon="Export" size="sm" style={{ marginRight: 'var(--arc-space-1)' }} />
                    <span>Exports</span>
                    <NotificationCounter style={{ marginLeft: 'var(--arc-space-2)' }}>
                        {state.notificationCount}
                    </NotificationCounter>
                </Button>
            </PopoverTrigger>
            <PopoverContent
                onFocusOutside={() => onPopoverChange(false)}
                align="center"
                side="bottom"
                hasPadding={false}
                style={{ top: '4px' }}
            >
                <Box
                    data-testid="EXPORTS_MENU"
                    minW={mediaAttachmentsEnabled ? '400px' : undefined}
                >
                    <Export />
                </Box>
            </PopoverContent>
        </Popover>
    );
}
